import React from "react";
import { NavigationPanelListItemType } from "../../types/components";
import NavigationPanelListItem from "./NavigationPanelListItem";
import { generateUniqueInteger } from "../../services/formatter";

const NavigationPanelList = ({ className, featureFlags, links, disableHoverBgColor = false, dataCy }: {
  className?: string,
  featureFlags?: string[],
  links: NavigationPanelListItemType[],
  disableHoverBgColor?: boolean,
  dataCy?: string,
}) => {
  const groupHasIcon = links.some((link: NavigationPanelListItemType) => link.icon);

  return (
    <ul className={`navigation-panel-list padding-left-none ${className} ${disableHoverBgColor ? "disable-hover-bg-color" : ""}`} data-cy={dataCy}>
      {links.map((link: NavigationPanelListItemType) => (
        <NavigationPanelListItem
          key={link.title + generateUniqueInteger()}
          data={link}
          featureFlags={featureFlags}
          includeIconSpacing={groupHasIcon}
        />
      ))}
    </ul>
  );
}

export default NavigationPanelList;